import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import {
  FAQ_ITEMS,
  FaqItem,
  HOMEPAGE_FAQ_IDS
} from '../../sites/faq/faq.data';

@Component({
  selector: 'app-home-faq',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home-faq.component.html',
  styleUrls: ['./home-faq.component.less']
})
export class HomeFaqComponent {

  readonly items: FaqItem[] = HOMEPAGE_FAQ_IDS
    .map(id => FAQ_ITEMS.find(f => f.id === id))
    .filter((i): i is FaqItem => !!i);

  openId: number | null = null;

  toggle(id: number): void {
    this.openId = this.openId === id ? null : id;
  }

  isOpen(id: number): boolean {
    return this.openId === id;
  }

  onKeydown(event: KeyboardEvent, id: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle(id);
    }
  }

  trackById(_: number, item: FaqItem): number {
    return item.id;
  }
}
